export default __webpack_public_path__ + "dce4ed4ebb843d56b35bd8f92eefcf27.png";